<template>
  <div class="CompanyProfile">
    <h2>企业资质</h2>
    <div class="heng"></div>
    <div class="content">
      <ul>
        <li v-for="(item, index) in srcList" :key="index">
          <img class="awardImg" @click="showImg(item.src)" :src="item.src" alt="" />
          <img class="bangdan" src="../../public/img/bangdan.png" alt="">
          <h3>{{item.name}}</h3>
        </li>
      </ul>
      <el-image
        style="height: 0"
        id="showImg"
        :src="currentImg"
        :preview-src-list="srcArr"
      >
      </el-image>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentImg: require("../../public/img/E0039748.png"),
      srcList: [
        {src:require("../../public/img/E0039748.png"),name:"森拓公益林图层建档更新系统V1.0"},
        {src:require("../../public/img/4632187.png"),name:"掌尚林草资源监测数据采集系统V1.0"},
        {src:require("../../public/img/4631948.jpg"),name:"森拓公益林年度变更调查系统V1.0"},
        {src:require("../../public/img/4389213.png"),name:"成都市森林资源监测外业数据采集系统V1.0"},
      ],
      srcArr:[],
    };
  },
  mounted() {
    this.srcArr = this.srcList.map(item=>{
      return item.src;
      })
  },
  methods: {
    showImg(src) {
      this.currentImg = src;
      $("#showImg").click();
    },
  },
};
</script>
<style lang="scss" scoped>
div.CompanyProfile {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding-top:54px;
   h2 {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1.75rem;
   
  }
  div.heng {
    width: 34px;
    border-bottom: 2px solid #00be92;
    margin: 10px auto;
    margin-bottom: 38px;
  }
  ul {
    margin: 0 auto;
    li {
      float: left;
      width: 270px;
      height: 560px;
      text-align: center;
      background: #f8f8f8;
      img.awardImg{
        width: 270px;
        height: 382px;
        cursor: pointer;
      }
      img.bangdan{
        margin-top:22px;
        margin-bottom:12px;
      }
      h3 {
        width: 174px;
        font-size: 1.125rem;
        line-height: 1.875rem;
        color: #595758;
        margin: 0 auto;
      }
    }
    li:not(:last-child) {
      margin-right: 40px;
    }
  }
}
</style>
